export default "__VITE_ASSET__D24DD30d__"